var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0466 7.38094C11.92 7.38094 11.7933 7.33427 11.6933 7.23427L7.99996 3.54094L4.30662 7.23427C4.11329 7.4276 3.79329 7.4276 3.59996 7.23427C3.40662 7.04094 3.40662 6.72094 3.59996 6.5276L7.64662 2.48094C7.83996 2.2876 8.15996 2.2876 8.35329 2.48094L12.4 6.5276C12.5933 6.72094 12.5933 7.04094 12.4 7.23427C12.3066 7.33427 12.1733 7.38094 12.0466 7.38094Z",
    fill: "#008042"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 14.6673C7.72667 14.6673 7.5 14.4406 7.5 14.1673L7.5 2.94727C7.5 2.67393 7.72667 2.44727 8 2.44727C8.27333 2.44727 8.5 2.67393 8.5 2.94727V14.1673C8.5 14.4406 8.27333 14.6673 8 14.6673Z",
    fill: "#008042"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow-up.eb87e2727ab9d73cb7dbd0344495e93d.svg";
export { ForwardRef as ReactComponent };